<template>
  <div class="modal-cover" @click="onClose" v-if="!isLeaved">
    <div class="participant-container" @click.stop>
      <div class="participant-header-container">
        <button class="close-modal" @click="onClose"></button>
        <div>{{ $t('camstudy.participant.title') }}</div>
        <div class="participant-invite-icon" @click="openInviteModal"></div>
      </div>
      <ul class="participant-body-container overflow-y-scroll">
        <li v-for="participant in filteredParticipants" :key="participant.id" class="participant-user-item">
          <div class="flex w-full overflow-hidden mr-3 items-center user-item-img-name">
<!--            <img v-if="getCamStudyUser(participant.userId)?.profileImageUrl" class="user-image"-->
<!--                 :src="getCamStudyUser(participant.userId)?.profileImageUrl" :alt="$t('common.user')">-->
<!--            <div v-else class="user-image none"></div>-->
            <div class="v-name-img">
              <UserProfileImage :user-id="participant.userId" />
              <GrmIcon icon=""
                       v-if="hasEmceeRole(participant.userId)"
                       :class="hasSpeakerRole(participant.userId) ? 'room-speaker' : 'room-emcee'"
              />
            </div>
            <div class="v-name-determine">
              <div class="user-name">{{ participant.nickname }}{{ isMe(participant.userId) ? $t('camstudy.participant.me') : '' }}</div>
              <div class="user-msg">{{ userMsg(participant.userId) }}</div>
            </div>
          </div>
          <!--   자기 자신일때는 보여지면 안됨     -->
          <div class="flex gap-2 flex-shrink-0" v-if="!isMe(participant.userId)">
            <div class="flex items-center justify-center" @click="blockUserScreen({userId: participant.userId, block: !isUserScreenBlock(participant.userId)})">
              <button class="screen-block" :class="{block: isUserScreenBlock(participant.userId)}"
              >{{ isUserScreenBlock(participant.userId) ? $t('camstudy.participant.unblockScreen') : $t('camstudy.participant.blockScreen') }}
            </button>
            </div>
            <!--   권한이 있을 경우에만       -->
            <div class="flex items-center justify-center"
                 v-if="hasEmceeRole() && !hasSpeakerRole(participant)"
                 @click="openSelectKickOrBanUser(participant)">
              <button class="exit-user">{{ $t('camstudy.participant.exit') }}</button>
            </div>
            <!--          <button class="exit-user" @click="banUser(participant)">차단</button>-->
            <button 
              v-if="hasEmceeRole()"
              class="permission-user"
              :class="{ active: selectedAciveUser === participant.userId }"
              @click="() => toggleUserPermission(participant)"
            >
              <div v-if="selectedAciveUser === participant.userId" class="permission-modal-cover" @click.stop>
                <div class="permission-modal" @click.stop>
                  <button class="permission-item" :disabled="!enableChangeRole('speaker')" @click="setRoleId(currentUser, 'speaker')">{{ $t('camstudy.participant.role.changeToSpeaker') }}</button>
                  <button class="permission-item" :disabled="!enableChangeRole('emcee')" @click="setRoleId(currentUser, 'emcee')">{{ $t('camstudy.participant.role.changeToEmcee') }}</button>
                  <button class="permission-item" :disabled="!enableChangeRole('participant')" @click="setRoleId(currentUser, 'participant')">{{ $t('camstudy.participant.role.changeToParticipant') }}</button>
                </div>
              </div>
            </button>
          </div>
        </li>
      </ul>
      <KickOrBanUser
          v-if="isMobile && isOpenKickOrBanUser" :user="selectedUser" @close="()=> {
        isOpenKickOrBanUser = false
        selectedUser = {}
      }"/>
    </div>
    <KickOrBanUser
        v-if="!isMobile && isOpenKickOrBanUser" :user="selectedUser" @close="()=> {
      isOpenKickOrBanUser = false
      selectedUser = {}
    }"/>
    <!--  이메일 초대  -->
    <div v-if="isOpenInviteModal" class="invite-container" @click.stop>
      <div class="invite-header-container">
        <div>{{ $t('camstudy.invite.title') }}</div>
      </div>
      <div class="invite-body-container overflow-y-scroll">
<!--        <div class="study-room-url-container">-->
<!--          <div class="flex justify-between items-center mb-1">-->
        <!--            <div class="study-room-url-title">{{ $t('camstudy.invite.studyRoomUrl') }}</div>-->
<!--            <div class="study-room-url-copy" @click="onCopyUrl"></div>-->
<!--          </div>-->
<!--          <div class="url-link">{{ getRoomUrl }}</div>-->
<!--        </div>-->
        <div class="pt-3">
          <div class="flex justify-between mb-3">
            <div class="invite-email-title">{{ $t('camstudy.invite.emailToInvite') }}</div>
            <div class="invite-email-text">{{ $t('camstudy.invite.onlyRegisteredEmails') }}</div>
          </div>
          <div>
            <div class="invite-email-input-container" :class="{wrong: isWrongEmailValidation}">
              <input type="text" class="invite-input" v-model="inviteInputData" />
              <div class="invite-button-container">
                <button class="invite-button" @click="onAddInviteUser">{{ $t('camstudy.invite.add') }}</button>
              </div>
            </div>
            <div v-if="isWrongEmailValidation" class="wrong-email">{{wrongMessage}}</div>
          </div>
          <div class="invite-user-list-container">
            <div class="invite-user-title">{{ $t('camstudy.invite.inviteeList') }} <span class="invite-user-count">{{getInviteUserListLength}}</span></div>
            <ul class="invite-user-list">
              <li class="invite-user" v-for="email in inviteUserList" :key="email">
                <div class="email">{{email}}</div>
                <button class="remove-email" :value="email" @click="onRemoveEmail"></button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="invite-footer">
        <button class="invite-footer-button cancel" @click="onCloseInviteModal">{{ $t('common.cancel') }}</button>
        <button class="invite-footer-button save" @click="onInviteUser">{{ $t('camstudy.invite.invitePeople', {count: getInviteUserListLength}) }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import UserProfileImage from "@/components/Room/User/UserProfileImage.vue";
// import GrmSimpleSelect from "@/components/Common/select/GrmSimpleSelect.vue";
import {Device} from "@/utils"
import GrmIcon from "@/components/Common/icon/GrmIcon.vue";
import KickOrBanUser from "@/components/Room/Camstudy/KickOrBanUser.vue";

export default {
  name: "CamstudyParticipantModal",
  components: {
    KickOrBanUser,
    GrmIcon,
    UserProfileImage
  },
  data() {
    return {
      step: 0,
      selectedUser: {},
      isOpenKickOrBanUser: false,
      isOpenInviteModal: false,
      inviteUserList: [],
      inviteInputData: '',
      isWrongEmailValidation: false,
      wrongMessage: '',
      isOpenPermissionModal: false,
      currentUser: '',
      selectedAciveUser: null,
    }
  },
  watch: {
    inviteInputData() {
      if(this.isWrongEmailValidation){
        this.isWrongEmailValidation = false;
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'me',
      'isMe',
      'isOpener',
      'getRoomUser',
      'roomUserList',
      'hasEmceeRole',
      'hasSpeakerRole',
      'hasUserInChannel',
      'isParticipantRole',
      'getUserDeviceStatus',
    ]),
    ...mapGetters('camstudy', [
      'getCamStudyUser',
      'isUserScreenBlock',
      'camStudyUserList',
    ]),
    ...mapGetters('room', [
      'room',
      'isLeaved',
    ]),
    userMsg() {
      return (userId) => {
        return this.getCamStudyUser(userId)?.myMsg
      }
    },
    myRole(){
      return this.roomUserList.find((v) => this.isMe(v.userId))?.roomUserRole?.roleId
    },
    userRoleName() {
      return (userId, showOnlyEmcee = false) => {
        const roleId = ['speaker', 'emcee', 'participant'].includes(userId)
            ? userId
            : this.getRoomUser(userId)?.roomUserRole?.roleId ?? userId

        switch (roleId) {
          case 'speaker':
            return this.$t('common.speaker');
          case 'emcee':
            return this.$t('common.emcee');
          case 'participant':
            if(showOnlyEmcee) return '';
            return this.$t('common.participant');
          case 'rtsp':
            return 'RTSP';
          default:
            return 'UNKNOWN';
        }
      }
    },
    filteredParticipants() {
      return this.roomUserList.filter(p => {
        // 옵저버 제외
        if (p.roomUserRole.roleId === 'obs') {
          return false;
        }

        // // 검색처리
        // if (this.userFilter.text.length > 0) {
        //   return p.nickname.includes(this.userFilter.text);
        // }

        return true;
      }).sort((a, b) => {
        if (this.isMe(a.userId)) {
          return -1
        }
        if (this.isMe(b.userId)) {
          return 1
        }

        if (this.isOpener(a.userId)) {
          return -1
        }
        if (this.isOpener(b.userId)) {
          return 1
        }

        if (this.orderBy === 'connected') {
          if (a.enterDate > b.enterDate) {
            return 1;
          }
          if (a.enterDate < b.enterDate) {
            return -1;
          }
          return 0;
        } else if (this.orderBy === 'nickname') {
          if (a.nickname > b.nickname) {
            return 1;
          }
          if (a.nickname < b.nickname) {
            return -1;
          }
          return 0;
        } else if (this.orderBy === 'username') {
          if (a.username > b.username) {
            return 1;
          }
          if (a.username < b.username) {
            return -1;
          }
          return 0;
        } else if (this.orderBy === 'role') {
          return this.userRoleLevel(a) - this.userRoleLevel(b)
        } else if (this.orderBy === 'layoutSeqNum') {
          if (b.layoutSeqNum < 0) return -1;
          return a.layoutSeqNum - b.layoutSeqNum
        }

        return 0;
      })
    },
    getInviteUserListLength(){
      return this.inviteUserList.length
    },
    isMobile(){
      return Device.isMobile()
    },
    enableChangeRole() {
      return (roleId, roomUser) => {
        const currentRoleId = roomUser?.roomUserRole?.roleId || this.currentUser.roomUserRole.roleId;
        if(currentRoleId === 'speaker'
            || currentRoleId === roleId
            || (roleId === 'speaker' && this.myRole !== 'speaker')
        ) return false;
        return true
      }
    }
  },
  methods: {
    ...mapActions('user', [
      'kickRoomUser',
      'changeRoomUserRoleId',
    ]),
    ...mapActions('camstudy', [
      'addCamStudyUserBan',
      'inviteUser',
      'isJoinedEmail',
    ]),
    ...mapMutations('camstudy', [
      'blockUserScreen',
    ]),
    onClose() {
      this.$modal('CamstudyParticipantModal', {once: true})
    },
    openSelectKickOrBanUser(roomUser) {
      if(this.hasSpeakerRole(roomUser)) return
      this.selectedUser = roomUser
      this.isOpenKickOrBanUser = true
    },

    openInviteModal(){
      this.isOpenInviteModal = true;
    },
    // onCopyUrl(){
    //   navigator.clipboard.writeText(this.getRoomUrl)
    // },
    async onAddInviteUser(){
      if(this.inviteUserList.find((v) => v === this.inviteInputData)){
        this.isWrongEmailValidation = true;
        this.wrongMessage = this.$t('camstudy.invite.errors.duplicateEmail');
        return;
      }

      if(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.inviteInputData)){
        this.isWrongEmailValidation = true;
        this.wrongMessage = this.$t('camstudy.invite.errors.invalidEmail');
        return;
      }

      const isJoinedEmail = await this.isJoinedEmail(this.inviteInputData);
      if(!isJoinedEmail) {
        this.isWrongEmailValidation = true;
        this.wrongMessage = this.$t('camstudy.invite.errors.notRegistered');
        return;
      }

      this.inviteUserList = this.inviteUserList.concat(this.inviteInputData)
      this.inviteInputData = '';
    },
    onRemoveEmail(e){
      const email = e.target.value;
      this.inviteUserList = this.inviteUserList.filter(v => v !== email)
    },
    onCloseInviteModal(){
      this.isOpenInviteModal = false;
    },
    async onInviteUser() {
      try {
        await this.inviteUser({
          roomTitle: this.room.roomTitle,
          roomUrlId: this.room.roomUrlId,
          roomType: this.room.roomType,
          hostname: this.me.nickname || this.me.username,
          destinations: this.inviteUserList
        });
        this.$camsAlert({
          text: this.$t('camstudy.invite.inviteSuccess', {count: this.inviteUserList.length}),
          ok: () => {
            this.onCloseInviteModal()
          },
          onlyOk: true
        });
      } catch (error) {
        console.error('## Failed to invite', error);
        this.$camsAlert({
          text: this.$t('camstudy.invite.errors.inviteFailed'),
          onlyOk: true
        });
      }
    },
    setRoleId(roomUser, roleId) {
      if(!this.enableChangeRole(roleId, roomUser)) return;

      const {userId, nickname} = roomUser;
      this.$camsAlert({
        text: this.$t('user.parti.changeRole', {'0': nickname, '1': this.userRoleName(roleId)}),
        ok: () => {
          this.changeRoomUserRoleId({userId, roleType: roleId})
        }
      })
    },
    toggleUserPermission(user){
      this.isOpenPermissionModal = true;
      this.currentUser = user;
      if(this.selectedAciveUser === user.userId){
        this.selectedAciveUser = null;
        return;
      }
      this.selectedAciveUser = user.userId; 
    },
    onClosePermissionModal(){
      this.isOpenPermissionModal = false;
      this.selectedAciveUser = null;
    }
  },
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .modal-cover{
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .participant-container{
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        .participant-body-container{
          height: calc(100% - 44px);
        }
      }
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;
        .participant-body-container{
          height: 331px;
        }
      }
    }
    .invite-container{
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        .invite-body-container{
          height: calc(100% - 95px);
        }
      }
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;
        .invite-body-container{
          height: 331px;
        }
      }
    }
  }
}
html:not([grm-device-mobile]){
  .modal-cover{
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;

    .participant-container {
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;

      .participant-body-container {
        height: calc(100% - 44px);
      }
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;
    }
    .invite-container{
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;
      .invite-body-container{
        height: calc(100% - 95px);
      }
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;
    }
  }
}
.modal-cover{
  position: fixed;
  top: 0;
  line-height: 1.5;
  z-index: 2;
}
.participant-container {
  position: absolute;
  background: #1F1F1F;
  color: white;
  z-index: 100;

  .participant-header-container {
    display: flex;
    padding: 6px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }

  .participant-body-container {
    padding: 12px 0;
    &::-webkit-scrollbar {
      display: none;
    }

    .participant-user-item {
      display: flex;
      padding: 8px 20px;
      justify-content: space-between;
      font-size: 14px;
      align-items: center;

      .user-item-img-name {
        height: 40px;
      }

      .v-name-img {
        position: relative;
        width: 28px;
        height: 28px;

        .room-speaker {
          position: absolute;
          right: -6px;
          bottom: -6px;
          width: 14px;
          height: 14px;
          border-radius: 6px;
          background: #FF7F00 url('~@/assets/images/crown_white.svg') no-repeat center / auto 72%;
          // background: white url('~@/assets/images/crown_blue.svg') no-repeat center / auto 80%;
          box-sizing: content-box;
          border: 2px solid #1F1F1F;
        }

        .room-emcee {
          position: absolute;
          right: -6px;
          bottom: -6px;
          width: 14px;
          height: 14px;
          border-radius: 6px;
          background: #666666 url('~@/assets/images/crown_white.svg') no-repeat center / auto 72%;
          // background: white url('~@/assets/images/crown_blue.svg') no-repeat center / auto 80%;
          box-sizing: content-box;
          border: 2px solid #1F1F1F;
        }
      }
    }

    .user-image {
      width: 28px;
      height: 28px;
      border-radius: 14px;
      margin-right: 14px;
      overflow: hidden;

      &.none {
        background: url("~@/assets/images/user_profile.svg") no-repeat;
        background-size: auto 100%;
      }
    }

    .v-name-determine {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 14px;
      flex: 1;
      max-width: calc(100% - 42px);
    }

    .user-name {
      font-size: 14px;
      color: white;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .user-msg {
      font-size: 12px;
      color: #999;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .screen-block, .exit-user {
      border-radius: 6px;
      padding: 4px 8px;
      font-size: 12px;
      color: white;      
      line-height: 18px;
    }

    .screen-block {      
      background: #393939;
    }

    .exit-user {
      background: #800000;
    }

    .permission-user{
      width: 32px;
      height: 32px;
      background: url("~@/assets/images/camstudy/ico_participant_permission.svg") no-repeat center / 60% auto;
      opacity: 0.5;

      &.active {
        opacity: 1;
      }
    }
  }

  .close-modal {
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }

  .participant-invite-icon {
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_participant_invite_white.svg") center no-repeat;
  }
}
.invite-container{
  position: absolute;
  background: #1F1F1F;
  color: white;
  z-index: 100;

  .invite-header-container {
    display: flex;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  .invite-body-container {
    padding: 12px 20px;
    &::-webkit-scrollbar {
      display: none;
    }
    .study-room-url-title, .invite-email-title{
      font-size: 14px;
    }
    .study-room-url-copy{
      width: 22px;
      height: 22px;
      margin: 5px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2) url("~@/assets/images/camstudy/ico_room_url_copy_white.svg") no-repeat center;
      background-size: auto 10px;
    }
    .url-link{
      padding: 8px 8px 8px 12px;
      border-radius: 6px;
      background: #393939;
      font-size: 14px;
      line-height: 150%;
    }
    .invite-email-text{
      display: flex;
      align-items: flex-end;
      font-size: 12px;
    }
    .wrong-email{
      color: #FF5353;
      font-size: 12px;
      margin-top: 8px;
    }
    .invite-email-input-container{
      height: 45px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 5px 8px 5px 12px;
      border-radius: 6px;
      background: black;
      
      .invite-input{
        font-size: 14px;
        line-height: 150%;
        width: 100%;
        height: 100%;
        background: transparent;
        outline: transparent;
      }
      .invite-button-container{
        padding: 4px;
        flex-shrink: 0;
        .invite-button{
          border-radius: 6px;
          color: #FFFFFF;
          font-size: 12px;
          padding: 4px 8px;
          background: #016FF2;
        }
      }
      &.wrong{
        border: 1px solid #FF5353;
        .invite-button{
          background: #393939;
          color: #999999;
        }
      }
    }
    .invite-user-list-container{
      padding: 12px 0;

      .invite-user-title{
        margin-bottom: 12px;
        font-size: 14px;

        .invite-user-count{
          margin-left: 6px;
          color: #2A8BFE;
          font-weight: 700;
        }
      }
      .invite-user-list{
        display: flex;
        gap: 12px;
        flex-direction: column;

        .invite-user{
          height: 32px;
          padding: 0 8px 0 12px;
          border-radius: 20px;
          background: #393939;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .email{
            font-size: 14px;
            color: white;
            line-height: 150%;
          }
          .remove-email{
            width: 32px;
            height: 32px;
            background: url("~@/assets/images/camstudy/ico_close_white.svg") no-repeat center;
            background-size: auto 16px;
          }
        }
      }
    }
  }
  .invite-footer{
    width: 100%;
    display: flex;
    .invite-footer-button{
      width: 100%;
      display: flex;
      padding: 15px 0 14px;
      justify-content: center;
      align-items: center;
      border-top: 0.333px solid rgba(255, 255, 255, 0.20);

      &.cancel{
        color: #999;
        font-size: 14px;
        line-height: 150%;
      }
      &.save{
        color: #FFF;
        font-size: 14px;
        font-weight: 700;
        line-height: 150%;
      }
    }
  }
}
[grm-device-mobile]{
  .permission-modal-cover{
    background: rgba(0, 0, 0, 0.5);
    bottom: 0;
    @media(orientation: portrait) {
      height: 375px;
    }
    @media(orientation: landscape) {
      top: 0;
    }
  }
  .permission-modal{
    left: 8px;
    right: 8px;
    bottom: 8px;
  }
}
html:not([grm-device-mobile]){
  .participant-container .participant-body-container .permission-user {
    position: relative;
  }
  .permission-modal-cover{
    background-color: transparent;
  }
  .permission-modal{
    top: 20px;
    right: 0;
    width: 140px;
    padding: 6px 0;
    box-shadow: 0 4px 16px rgba(0,0,0,0.3);

    .permission-item {
      padding: 8px 16px;

      &:hover {
        background-color: rgba(255,255,255,0.1);
      }
    }
  }
}
.permission-modal-cover{
  position: absolute;
  left: 0;
  right: 0;
  z-index: 100;
}
.permission-modal{
  position: absolute;
  padding: 12px 0;
  border-radius: 12px;
  background: #313131;
  display: flex;
  flex-direction: column;

  .permission-item{
    width: 100%;
    padding: 12px 20px;
    color: #FFF;
    font-size: 14px;
    text-align: left;

    &:disabled{
      color: #999;
      font-size: 14px;
    }
  }
}
</style>